import NewsletterPage from './newsletters_page_marketo';

export default function() {
  const routeConfig = {
    path: '/newsletters',
    component: NewsletterPage,
    exact: true,
    strict: true,
    chunk: 'newslettersPage'
  };

  return routeConfig;
}
